<template>
  <v-fade-transition>
    <div v-show="show" class="loader no-select" :style="`position: ${position}; cursor: ${cursor};z-index:${zindex};`">
      <v-progress-circular
          v-if="circle"
          class="loader__progress"
          indeterminate
          :size="size"
          :width="stroke"
          :color="color"
      ></v-progress-circular>
    </div>
  </v-fade-transition>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'LOADER',

  props: {
    zindex: {
      type: Number,
      default: 2
    },
    show: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: true
    },
    size: {
      type: Number,
      default: 100
    },
    stroke: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      default: 'secondary'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    cursor: {
      type: String,
      default: 'auto'
    },
  },
})
</script>

<style lang="stylus">

    .loader

        display: flex
        flex-direction: column

        align-items: center
        align-content: center
        justify-content: center

        /* position: fixed */
        z-index: 2

        top: 0
        left: 0
        right: 0
        bottom: 0

        background-color: alpha(#ffffff, .6)


        &__progress

            // opacity: .7

    .fade-transition

        &-leave-active

            transition: opacity 3s ease

        &-enter-active, &-leave, &-leave-to

            // transition: $primary-transition
            transition: opacity 1s ease

        &-enter, &-leave-to

            opacity: 0


</style>
